<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Add Equipment Servicing Schedule'|translate}}
          </v-card-title>
          <v-card-text>
              <v-text-field :label="'Name'|translate" v-model="name"></v-text-field>
              <v-textarea :label="'Description'|translate" v-model="desc">
              </v-textarea>
              <v-radio-group v-model="filterMode" :mandatory="true" :label="'Applies to'|translate">
                  <v-radio :label="'Equipment'|translate" :value="'equipment'"></v-radio>
                  <v-radio :label="'Floor'|translate" :value="'floor'"></v-radio>
                  <v-radio :label="'Entire Site'|translate" :value="'site'"></v-radio>
              </v-radio-group>
              <equipment-selector v-show="filterMode=='equipment'" v-model="equipment_name" clearable></equipment-selector>
              <equipment-selector v-show="filterMode=='floor'" floor-mode :label="'Floor Name'|translate" v-model="floor_name" clearable></equipment-selector>
              <date-range-selector v-model="range"></date-range-selector>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outline class="mr-2" @click="dialog=false">{{'Cancel'|translate}}</v-btn>
              <v-btn class="primary mr-2 elevation-4" @click="addRecord()" :disabled="!$can('update', 'EquipmentServicingSchedule')">{{'Save'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
    import EquipmentSelector from "./EquipmentSelector";
  import {putEquipmentServicingSchedule} from '../helper'
    import DateRangeSelector from "./DateRangeSelector";
  export default {
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
      components:{EquipmentSelector,DateRangeSelector},
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.ess_id = item['ess_id']
          this.name= item['name']
            this.range = {start: item['start_date'], end: item['end_date']}
          this.desc = item['desc']
          this.equipment_name = item['equipment_name']
          this.floor_name = item['floor_name']
        }
        if(this.equipment_name){
            this.filterMode='equipment'
        } else if(this.floor_name){
            this.filterMode='floor'
        }else {
            this.filterMode='site'
        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
          name: '',
          desc: null,
          ess_id:null,
          equipment_name: null,
          range: null,
          floor_name: null,
          filterMode:'site'
      }
    },
    methods: {
      initializeVar() {
        this.name= null
        this.desc= null
        this.filterMode='site'
        this.equipment_name= null
        this.floor_name= null
        this.ess_id = null
          this.range=null
      },
      async addRecord () {
          let payload={
              'ess_id': this.ess_id,
              'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
              'name': this.name,
              'desc': this.desc,
              'start_date': this.range.start,
              'end_date': this.range.end,
          }
          if(this.filterMode=='equipment'){
              payload.equipment_name=this.equipment_name
          } else if (this.filterMode=="floor"){
              payload.floor_name=this.floor_name
          }
          await putEquipmentServicingSchedule(
              payload
          )
          this.$emit('doreload')
          this.dialog=false
      }
    },
    name: 'EquipmentServicingScheduleDialog'
  }
</script>

<style scoped>

</style>
